// "convenient" is a legacy name of "approximate" steps.
export { default as approximate, default as convenient } from './approximate'; // "canonical" is a legacy name of "round" steps.

export { default as round, default as canonical } from './round';
export { minute, hour, day, week, month, year } from './units';
export { getDate } from './helpers';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/javascript-time-ago/modules/steps/index.js
// module id = 3256
// module chunks = 0